import moment from 'moment';
import store from '../..';
import { filter, getFilters } from '@/_store/utils/app/filter';
import { stringyObject } from '@/_store/utils/helpers';
import { getAll } from '@/api';

export async function createRequest(filterParams, callString, typeName) {
  let variables = '';
  if (filterParams) {
    variables = `filters: ${stringyObject(filter(filterParams))}`;
  }
  const clientTable = store.getters['account/getCurrentClient'].table_name;

  const user_groups = store.getters['account/getCurrentUser'].group_id
    && store.getters['account/getCurrentUser'].group_id[0];

  let index;
  if (user_groups && user_groups !== 'all') {
    if (typeName === 'group') {
      index = `group: ${stringyObject({ uuid: user_groups })},`;
    } else {
      variables.group_id = user_groups;
      index = 'index: "all-index",';
    }
  } else {
    index = 'index: "all-index",';
  }

  const filters = getFilters();
  let sdate;
  let edate;

  if (
    filters.start_date !== ''
    && filters.start_date !== undefined
    && filters.end_date !== ''
    && filters.end_date !== undefined
  ) {
    sdate = moment(filters.start_date).format('X');
    edate = moment(filters.end_date).format('X');
  }

  const dates = sdate
    ? `
    sdate: ${sdate},
    edate: ${edate}, 
  `
    : '';

  const query = `{
    get(
      type_name: "${typeName}", 
      ${variables}, 
      table_name:"${clientTable}",
      ${index}
      ${dates}
    )
      ${callString},
  }`;

  return await getAll(`/${typeName}?query=${encodeURIComponent(query)}`);
}
